import { isDefined } from './is-defined.guard';

/**
 * Type guard that checks if a value is of a specific type by verifying the presence of specified properties.
 *
 * @template T - The type to check against.
 * @param value - The value to check.
 * @param propertyToCheckFor - The properties that should be present in the value to confirm its type.
 * @returns `true` if the value is defined and contains all specified properties, otherwise `false`.
 */
export const isOfType = <T>(value: unknown, ...propertyToCheckFor: (keyof T)[]): value is T => {
  if (!isDefined(value)) {
    return false;
  }

  for (const property of propertyToCheckFor) {
    if (typeof (value as T)[property] === 'undefined') {
      return false;
    }
  }

  return true;
};
